import { render, staticRenderFns } from "./ProMateriaLibrary.vue?vue&type=template&id=2c037d5f&"
import script from "./ProMateriaLibrary.vue?vue&type=script&lang=js&"
export * from "./ProMateriaLibrary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProMateriaLibrary.vue"
export default component.exports